export const COOKIE_I18N_LANG = 'bb-locale';
export const COOKIE_BB_MARKET = 'bb-market';
